import singleAdapter from "../blog/adapter";

const adapter = {
  responseBodyToRender(input){
    let output = []

    if(input && input.length > 0){
      output = input.map(i => singleAdapter.responseBodyToRender(i))
    }

    return output
  },

  /**
   * Adapt response body from API to match a react-select options
   */
  responseBodyToOptions(input){
    const CONFIG = {
      title: 'judulArtikel',
      titleIndex: 0, // <<< in Bahasa Indonesia,
      id: 'blogId'
    }

    let result = [];

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const element = input[index];
        const option = {
          label: element[CONFIG.title][CONFIG.titleIndex],
          value: element[CONFIG.id]
        }

        result.push(option)
      }
    }

    return result
  },
}

export default adapter
